import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { Modal } from "src/components/modals/modal";
import { Modals, ModalsAction, UserSession } from "src/store";
import { Gift } from "src/components/svg";

export const ProfileCompletedMessageModal: React.FC = () => {

    const dispatch = useDispatch();
    const modals: Modals = useSelector((state: any) => state.ModalsState);
    const user: UserSession = useSelector((state: any) => state.UserState);

    const onClose = () => {
        dispatch(ModalsAction.hideProfileCompletedMessage());
    };

    const renderFooter = () => {
        return (
            <div className="col-xs-12 col-sm-4 offset-sm-4">
                <button className="btn btn-submit w-100 focusable" tabIndex={0} onClick={onClose}>
                    {user.user?.updateNotify?.promoSuccessConfirmText}
                </button>
            </div>
        );
    }

    const renderBody = () => {
        return (
            <div className="d-flex flex-column justify-content-center align-items-center">
                <div className="profile-icon"> {user.user?.updateNotify?.promoSuccessIcon ? <img src={user.user?.updateNotify?.promoSuccessIcon} alt="" /> : <Gift />}</div>
                <p className="text-center rtl">{user.user?.updateNotify?.promoSuccessMessage}</p>
            </div>
        )
    }

    return (
        <Modal title={user.user?.updateNotify?.promoSuccessTitle} show={modals.profileCompletedMessage} onClose={onClose} renderFooter={renderFooter} className="modal-component--profile">
            <div className="content text-right">
                {renderBody()}
            </div>
        </Modal>
    );
}